"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddLead = () => {
  const [leadTypes, setLeadTypes] = useState([]);
  const [leadStatus, setLeadStatus] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [lookingForOptions, setLookingForOptions] = useState([]);

  const [formData, setFormData] = useState({
    lead_type: "",
    customer_name: "",
    customer_email: "",
    customer_phone: "",
    customer_state: "",
    looking_for: "",
    customer_requirements: "",
    lead_status: "",
  });

  useEffect(() => {
    fetchLeadTypes();
    fetchLeadStatus();
    fetchLookingFor();
  }, []);

  const fetchLeadTypes = async () => {
    const res = await axios.get(
      "https://logicx.premierlam.com/api/get-pixel-lead-type",
      { headers: { authorization: localStorage.getItem("accessToken") } }
    );
    setLeadTypes(
      (res.data.data || []).map((l) => ({
        value: l.lead_type,
        label: l.lead_type,
      }))
    );
  };

  const fetchLeadStatus = async () => {
    const res = await axios.get(
      "https://logicx.premierlam.com/api/get-pixel-lead-status",
      { headers: { authorization: localStorage.getItem("accessToken") } }
    );
    setLeadStatus(
      (res.data.data || []).map((l) => ({
        value: l.lead_status,
        label: l.lead_status,
      }))
    );
  };

  const fetchLookingFor = async () => {
    const res = await axios.get(
      "https://logicx.premierlam.com/api/get-pixel-lead-looking-for",
      { headers: { authorization: localStorage.getItem("accessToken") } }
    );

    setLookingForOptions(
      (res.data.data || []).map((l) => ({
        value: l.looking_for,
        label: l.looking_for,
      }))
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.customer_phone.length !== 10) {
      toast.error("Customer phone must be exactly 10 digits");
      return;
    }

    try {
      setIsSubmitting(true);

      await axios.post(
        "https://logicx.premierlam.com/api/add-pixel-all-leads-data",
        formData,
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Lead added successfully!");
      setFormData({
        lead_type: "",
        customer_name: "",
        customer_email: "",
        customer_phone: "",
        customer_state: "",
          looking_for: "",  
        customer_requirements: "",
        lead_status: "",
      });
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to add lead");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="min-h-screen bg-gray-50 p-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <h1 className="text-2xl font-semibold mb-6">Add Lead</h1>

            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-1 md:grid-cols-2 gap-6"
            >
              {/* LEAD TYPE */}
              <div>
                <label className="text-sm font-medium">Lead Type</label>
                <Select
                  options={leadTypes}
                  value={
                    formData.lead_type
                      ? { value: formData.lead_type, label: formData.lead_type }
                      : null
                  }
                  onChange={(selected) =>
                    setFormData((prev) => ({
                      ...prev,
                      lead_type: selected.value,
                    }))
                  }
                  placeholder="Select Lead Type"
                />
              </div>

              {/* CUSTOMER NAME */}
              <div>
                <label className="text-sm font-medium">Customer Name</label>
                <input
                  type="text"
                  name="customer_name"
                  value={formData.customer_name}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                  required
                />
              </div>

              {/* EMAIL */}
              <div>
                <label className="text-sm font-medium">Customer Email</label>
                <input
                  type="email"
                  name="customer_email"
                  value={formData.customer_email}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                  required
                />
              </div>

              {/* PHONE */}
              <div>
                <label className="text-sm font-medium">
                  Customer Phone (10 digits)
                </label>
                <input
                  type="text"
                  name="customer_phone"
                  value={formData.customer_phone}
                  onChange={(e) => {
                    if (/^\d{0,10}$/.test(e.target.value)) {
                      handleChange(e);
                    }
                  }}
                  className="w-full border px-3 py-2 rounded"
                  required
                />
              </div>

              {/* STATE */}
              <div>
                <label className="text-sm font-medium">Customer State</label>
                <input
                  type="text"
                  name="customer_state"
                  value={formData.customer_state}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                  required
                />
              </div>
              {/* LOOKING FOR */}
              <div>
                <label className="text-sm font-medium">Looking For</label>
                <Select
                  options={lookingForOptions}
                  value={
                    formData.looking_for
                      ? { value: formData.looking_for, label: formData.looking_for }
                      : null
                  }
                  onChange={(selected) =>
                    setFormData((prev) => ({
                      ...prev,
                      looking_for: selected.value,
                    }))
                  }
                  placeholder="Select What Customer Is Looking For"
                />
              </div>


              {/* LEAD STATUS */}
              <div>
                <label className="text-sm font-medium">Lead Status</label>
                <Select
                  options={leadStatus}
                  value={
                    formData.lead_status
                      ? {
                        value: formData.lead_status,
                        label: formData.lead_status,
                      }
                      : null
                  }
                  onChange={(selected) =>
                    setFormData((prev) => ({
                      ...prev,
                      lead_status: selected.value,
                    }))
                  }
                  placeholder="Select Lead Status"
                />
              </div>

              {/* REQUIREMENTS */}
              <div className="md:col-span-2">
                <label className="text-sm font-medium">
                  Customer Requirements
                </label>
                <textarea
                  name="customer_requirements"
                  value={formData.customer_requirements}
                  onChange={handleChange}
                  rows={3}
                  className="w-full border px-3 py-2 rounded"
                  required
                />
              </div>

              {/* ACTION */}
              <div className="md:col-span-2 flex justify-end">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded"
                >
                  {isSubmitting ? "Adding..." : "Add Lead"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddLead;
